var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isRegistered == "1"
      ? _c("div", { staticClass: "login login2" }, [
          _c("div", { staticClass: "loginTop" }, [
            _c("div", { staticClass: "loginLogo warp" }, [
              _c(
                "div",
                { staticClass: "loginImgBox", on: { click: _vm.goToIndex } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/dlogo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "register" }, [_vm._v("注册")])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rightBox" }, [
                _c(
                  "span",
                  { staticClass: "loginText", on: { click: _vm.registered } },
                  [_vm._v("登录")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "brackIndex", on: { click: _vm.goToIndex } },
                  [_vm._v("返回首页")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "registerCent registerCent2" }, [
            _c("div", { staticClass: "loginBox warp" }, [
              _c(
                "div",
                { staticClass: "loginForm" },
                [
                  _c("div", { staticClass: "loginTit" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { class: _vm.line2 }),
                    _vm._v(" "),
                    _c("div", { class: _vm.class2 }, [
                      _c("span", { staticClass: "number" }, [_vm._v("2")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [_vm._v("设置密码")])
                    ]),
                    _vm._v(" "),
                    _c("div", { class: _vm.line3 }),
                    _vm._v(" "),
                    _c("div", { class: _vm.class3 }, [
                      _c("span", { staticClass: "number" }, [_vm._v("3")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [_vm._v("注册成功")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
                    _vm.registerConfirm == false
                      ? _c(
                          "div",
                          { staticClass: "loginFormBox" },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "ruleForm",
                                staticClass: "demo-ruleForm",
                                attrs: {
                                  model: _vm.register,
                                  rules: _vm.rules,
                                  "label-width": "120px"
                                }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "手机号", prop: "phone" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticClass: "iptHeight",
                                          attrs: {
                                            type: "text",
                                            "auto-complete": "off",
                                            placeholder: "请输入手机号"
                                          },
                                          model: {
                                            value: _vm.register.phone,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "phone",
                                                $$v
                                              )
                                            },
                                            expression: "register.phone"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "图形验证码",
                                      prop: "imgcode"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticClass: "iptHeight",
                                          attrs: {
                                            type: "text",
                                            "auto-complete": "off",
                                            placeholder: "请输入图形验证码"
                                          },
                                          model: {
                                            value: _vm.register.imgcode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "imgcode",
                                                $$v
                                              )
                                            },
                                            expression: "register.imgcode"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "codeBtn" }, [
                                          _c("img", {
                                            staticClass: "logincode",
                                            attrs: { src: _vm.codeUrl },
                                            on: { click: _vm.getImgCode }
                                          })
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "验证码", prop: "code" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "315px" },
                                          attrs: {
                                            placeholder: "请输入验证码"
                                          },
                                          model: {
                                            value: _vm.register.code,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "code",
                                                $$v
                                              )
                                            },
                                            expression: "register.code"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.codeShow,
                                                expression: "codeShow"
                                              }
                                            ],
                                            staticClass: "codeBtn",
                                            on: {
                                              click: function($event) {
                                                return _vm.getCode(
                                                  _vm.register.phone
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("获取验证码")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.codeShow,
                                                expression: "!codeShow"
                                              }
                                            ],
                                            staticClass: "codeBtn codeCount"
                                          },
                                          [
                                            _vm._v(
                                              "重新获取(" +
                                                _vm._s(_vm.codeCountNum) +
                                                "s)"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "用户名", prop: "userName" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticClass: "iptHeight",
                                          attrs: {
                                            type: "text",
                                            "auto-complete": "off",
                                            placeholder:
                                              "请输入字母或者字母加数字或者纯数字"
                                          },
                                          model: {
                                            value: _vm.register.userName,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "userName",
                                                $$v
                                              )
                                            },
                                            expression: "register.userName"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "设置密码",
                                      prop: "password"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticClass: "iptHeight",
                                          attrs: {
                                            type: "password",
                                            "auto-complete": "off",
                                            placeholder:
                                              "设置6-22位数字和字母组合"
                                          },
                                          on: { blur: _vm.handleblur },
                                          model: {
                                            value: _vm.register.password,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "register.password"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "确认密码", prop: "verify" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "inputBox" },
                                      [
                                        _c("el-input", {
                                          staticClass: "iptHeight",
                                          attrs: {
                                            type: "password",
                                            "auto-complete": "off",
                                            placeholder: "请再次确认"
                                          },
                                          model: {
                                            value: _vm.register.verify,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.register,
                                                "verify",
                                                $$v
                                              )
                                            },
                                            expression: "register.verify"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.Register("ruleForm")
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ],
                          1
                        )
                      : _c("div", { staticClass: "regSuccess" }, [
                          _c("div", { staticClass: "icon" }, [
                            _c("i", { staticClass: "el-icon-success" })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text" }, [
                            _vm._v("恭喜你注册成功!")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toLogin",
                              staticStyle: { "text-align": "center" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "fs16 mar-bot-5",
                                  attrs: { type: "primary", size: "medium" },
                                  on: { click: _vm.goToIndex }
                                },
                                [_vm._v("进入首页")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "fs16 mar-bot-5",
                                  attrs: { type: "primary", size: "medium" },
                                  on: { click: _vm.goToApprove }
                                },
                                [_vm._v("企业认证")]
                              )
                            ],
                            1
                          )
                        ])
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footText footText2" }, [
            _vm._v("\n      保山数字产业发展有限责任公司\n    ")
          ])
        ])
      : _vm.isRegistered == "2"
      ? _c(
          "div",
          { staticClass: "login login2" },
          [
            _c("div", { staticClass: "loginTop" }, [
              _c("div", { staticClass: "loginLogo warp" }, [
                _c(
                  "div",
                  { staticClass: "loginImgBox", on: { click: _vm.goToIndex } },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/dlogo.png"),
                        alt: ""
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "rightBox" }, [
                  _c(
                    "span",
                    { staticClass: "loginText", on: { click: _vm.goToIndex } },
                    [_vm._v("返回首页")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "loginCent loginCent2" }, [
              _c("div", { staticClass: "loginBox warp" }, [
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "loginForm" },
                  [
                    _c("div", {
                      staticClass: "loginTit",
                      domProps: {
                        textContent: _vm._s(
                          _vm.isRegistered == "1"
                            ? ""
                            : "欢迎登录小黄牛供应链平台"
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "loginType" }, [
                      _c(
                        "span",
                        {
                          staticClass: "account",
                          class: _vm.classType1,
                          on: { click: _vm.changeType }
                        },
                        [_vm._v("账号登录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "code",
                          class: _vm.classType2,
                          on: { click: _vm.changeType }
                        },
                        [_vm._v("验证码登录")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("a-spin", { attrs: { spinning: _vm.spinning } }, [
                      _vm.loginType == true
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "text",
                                    maxlength: "30",
                                    "auto-complete": "off",
                                    placeholder: "手机号/用户名"
                                  },
                                  model: {
                                    value: _vm.username,
                                    callback: function($$v) {
                                      _vm.username = $$v
                                    },
                                    expression: "username"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: _vm.passwordType,
                                    placeholder: "请输入密码"
                                  },
                                  model: {
                                    value: _vm.password,
                                    callback: function($$v) {
                                      _vm.password = $$v
                                    },
                                    expression: "password"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-pwd",
                                    on: { click: _vm.showPwd }
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        "icon-class":
                                          _vm.passwordType === "password"
                                            ? "eye"
                                            : "eye-open"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "inputBox",
                                staticStyle: { "margin-bottom": "30px" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.imgVerifyCode,
                                    callback: function($$v) {
                                      _vm.imgVerifyCode = $$v
                                    },
                                    expression: "imgVerifyCode"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "codeBtn", attrs: { v: "" } },
                                  [
                                    _c("img", {
                                      staticClass: "logincode",
                                      attrs: { src: _vm.codeUrl },
                                      on: { click: _vm.getImgCode }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.isRegistered === "1"
                                      ? "注册"
                                      : "立即登录"
                                  )
                                },
                                on: { click: _vm.getLoginPwd }
                              },
                              [
                                _vm._v(
                                  "\n                立即登录\n              "
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "text",
                                    maxlength: "30",
                                    "auto-complete": "off",
                                    placeholder: "手机号"
                                  },
                                  model: {
                                    value: _vm.phone,
                                    callback: function($$v) {
                                      _vm.phone = $$v
                                    },
                                    expression: "phone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入图形验证码" },
                                  model: {
                                    value: _vm.imgVerifyCode,
                                    callback: function($$v) {
                                      _vm.imgVerifyCode = $$v
                                    },
                                    expression: "imgVerifyCode"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "codeBtn", attrs: { v: "" } },
                                  [
                                    _c("img", {
                                      staticClass: "logincode",
                                      attrs: { src: _vm.codeUrl },
                                      on: { click: _vm.getImgCode }
                                    })
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "inputBox",
                                staticStyle: { "margin-bottom": "30px" }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.verificationCode,
                                    callback: function($$v) {
                                      _vm.verificationCode = $$v
                                    },
                                    expression: "verificationCode"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.codeShow,
                                        expression: "codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getCode(_vm.phone)
                                      }
                                    }
                                  },
                                  [_vm._v("获取验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.codeShow,
                                        expression: "!codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn codeCount"
                                  },
                                  [
                                    _vm._v(
                                      "重新获取(" +
                                        _vm._s(_vm.codeCountNum) +
                                        "s)"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.isRegistered === "1"
                                      ? "注册"
                                      : "立即登录"
                                  )
                                },
                                on: { click: _vm.login }
                              },
                              [
                                _vm._v(
                                  "\n                立即登录\n              "
                                )
                              ]
                            )
                          ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "noLogin",
                        class: { registered: _vm.isRegistered === "1" }
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.isRegistered === "1" ? "" : "用户注册"
                            )
                          },
                          on: { click: _vm.registered }
                        })
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footText footText2" }, [
              _vm._v(
                "\n      COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED\n      滇ICP备2021004155号\n    "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "服务协议",
                  visible: _vm.dialogAgreement,
                  width: "50%"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.dialogAgreement = $event
                  }
                }
              },
              [_vm._v("\n      这是服务协议\n    ")]
            )
          ],
          1
        )
      : _vm.isRegistered == "3"
      ? _c("div", { staticClass: "login" }, [
          _c("div", { staticClass: "loginTop" }, [
            _c("div", { staticClass: "loginLogo warp" }, [
              _c(
                "div",
                { staticClass: "loginImgBox", on: { click: _vm.goToIndex } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/dlogo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "register" }, [_vm._v("找回密码")])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rightBox" }, [
                _c(
                  "span",
                  { staticClass: "loginText", on: { click: _vm.registered2 } },
                  [_vm._v("注册")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "brackIndex", on: { click: _vm.registered } },
                  [_vm._v("登录")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "brackIndex", on: { click: _vm.goToIndex } },
                  [_vm._v("返回首页")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "registerCent" }, [
            _c("div", { staticClass: "loginBox warp" }, [
              _c("div", { staticClass: "loginForm" }, [
                _vm.findPassword == true
                  ? _c("div", [
                      _vm._m(3),
                      _vm._v(" "),
                      _vm.registerConfirm == false
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("登录名")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "text",
                                    "auto-complete": "off",
                                    placeholder: "手机/用户名"
                                  },
                                  model: {
                                    value: _vm.findForm.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.findForm, "phone", $$v)
                                    },
                                    expression: "findForm.phone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("验证码")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "315px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.findForm.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.findForm, "code", $$v)
                                    },
                                    expression: "findForm.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.codeShow,
                                        expression: "codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getCode(_vm.findForm.phone)
                                      }
                                    }
                                  },
                                  [_vm._v("获取验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.codeShow,
                                        expression: "!codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn codeCount"
                                  },
                                  [
                                    _vm._v(
                                      "重新获取(" +
                                        _vm._s(_vm.codeCountNum) +
                                        "s)"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.Find()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ])
                        : _c("div", { staticClass: "regSuccess" }, [
                            _vm._m(4),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("恭喜你注册成功!")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "toLogin",
                                  on: { click: _vm.registered }
                                },
                                [_vm._v("登录")]
                              )
                            ])
                          ])
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "loginTit" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("div", { class: _vm.line2 }),
                        _vm._v(" "),
                        _c("div", { class: _vm.class2 }, [
                          _c("span", { staticClass: "number" }, [_vm._v("2")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("找回密码")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { class: _vm.line3 }),
                        _vm._v(" "),
                        _c("div", { class: _vm.class3 }, [
                          _c("span", { staticClass: "number" }, [_vm._v("3")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [_vm._v("完成")])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.findStep == "1"
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c("div", { staticClass: "inputBox" }, [
                              _c("div", {}, [
                                _c("span", [_vm._v("手机验证码验证 账户")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "phone" }, [
                                  _vm._v(_vm._s(_vm.findForm.phone))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("为确认是你本人操作,请完成一下验证")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("手机号")]),
                                _vm._v(" "),
                                _vm.nouse == false
                                  ? _c("el-input", {
                                      staticClass: "iptHeight",
                                      attrs: {
                                        type: "text",
                                        "auto-complete": "off",
                                        placeholder: "手机/用户名"
                                      },
                                      model: {
                                        value: _vm.findForm.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.findForm, "phone", $$v)
                                        },
                                        expression: "findForm.phone"
                                      }
                                    })
                                  : _c("span", { staticClass: "yesuse" }, [
                                      _c("span", { staticClass: "phone" }, [
                                        _vm._v(_vm._s(_vm.findForm.phone))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "alter",
                                          on: {
                                            click: function($event) {
                                              return _vm.Nouse()
                                            }
                                          }
                                        },
                                        [_vm._v("[手机不可用?点此修改]")]
                                      )
                                    ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("验证码")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.setNew.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "code", $$v)
                                    },
                                    expression: "setNew.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.codeShow,
                                        expression: "codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getCode(_vm.etNew.phone)
                                      }
                                    }
                                  },
                                  [_vm._v("获取验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.codeShow,
                                        expression: "!codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn codeCount"
                                  },
                                  [
                                    _vm._v(
                                      "重新获取(" +
                                        _vm._s(_vm.codeCountNum) +
                                        "s)"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.FindSet()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            ),
                            _vm._v(" "),
                            _vm._m(6)
                          ])
                        : _vm.findStep == "2"
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c(
                                  "label",
                                  { staticStyle: { width: "115px" } },
                                  [_vm._v("设置新密码")]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "password",
                                    "auto-complete": "off",
                                    placeholder: "请设置新密码"
                                  },
                                  model: {
                                    value: _vm.setNew.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "password", $$v)
                                    },
                                    expression: "setNew.password"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c(
                                  "label",
                                  { staticStyle: { width: "115px" } },
                                  [_vm._v("确认新密码")]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "password",
                                    "auto-complete": "off",
                                    placeholder: "请再次确认新密码"
                                  },
                                  model: {
                                    value: _vm.setNew.verify,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "verify", $$v)
                                    },
                                    expression: "setNew.verify"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.FindConfirm()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ])
                        : _c("div", { staticClass: "regSuccess" }, [
                            _vm._m(7),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("重置成功，请牢记新的登录密码噢~!")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "toLogin",
                                  on: { click: _vm.registered }
                                },
                                [_vm._v("重新登录")]
                              )
                            ])
                          ])
                    ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footText" }, [
            _vm._v(
              "\n      COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED\n      滇ICP备2021004155号\n    "
            )
          ])
        ])
      : _c("div", { staticClass: "login" }, [
          _c("div", { staticClass: "loginTop" }, [
            _c("div", { staticClass: "loginLogo warp" }, [
              _c(
                "div",
                { staticClass: "loginImgBox", on: { click: _vm.goToIndex } },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/dlogo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "register" }, [
                    _vm._v("找回用户名")
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "rightBox" }, [
                _c(
                  "span",
                  { staticClass: "loginText", on: { click: _vm.registered2 } },
                  [_vm._v("注册")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "brackIndex", on: { click: _vm.registered } },
                  [_vm._v("登录")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "brackIndex", on: { click: _vm.goToIndex } },
                  [_vm._v("返回首页")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "registerCent" }, [
            _c("div", { staticClass: "loginBox warp" }, [
              _c("div", { staticClass: "loginForm" }, [
                _vm.findPassword == true
                  ? _c("div", [
                      _vm._m(8),
                      _vm._v(" "),
                      _vm.registerConfirm == false
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("登录名")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "text",
                                    "auto-complete": "off",
                                    placeholder: "手机/用户名"
                                  },
                                  model: {
                                    value: _vm.findForm.phone,
                                    callback: function($$v) {
                                      _vm.$set(_vm.findForm, "phone", $$v)
                                    },
                                    expression: "findForm.phone"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("验证码")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.findForm.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.findForm, "code", $$v)
                                    },
                                    expression: "findForm.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.codeShow,
                                        expression: "codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getCode(_vm.findForm.phone)
                                      }
                                    }
                                  },
                                  [_vm._v("获取验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.codeShow,
                                        expression: "!codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn codeCount"
                                  },
                                  [
                                    _vm._v(
                                      "重新获取(" +
                                        _vm._s(_vm.codeCountNum) +
                                        "s)"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.Find()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ])
                        : _c("div", { staticClass: "regSuccess" }, [
                            _vm._m(9),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("恭喜你注册成功!")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "toLogin",
                                  on: { click: _vm.registered }
                                },
                                [_vm._v("登录")]
                              )
                            ])
                          ])
                    ])
                  : _c("div", [
                      _c("div", { staticClass: "loginTit" }, [
                        _vm._m(10),
                        _vm._v(" "),
                        _c("div", { class: _vm.line2 }),
                        _vm._v(" "),
                        _c("div", { class: _vm.class2 }, [
                          _c("span", { staticClass: "number" }, [_vm._v("2")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("找回密码")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { class: _vm.line3 }),
                        _vm._v(" "),
                        _c("div", { class: _vm.class3 }, [
                          _c("span", { staticClass: "number" }, [_vm._v("3")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text" }, [_vm._v("完成")])
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.findStep == "1"
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c("div", { staticClass: "inputBox" }, [
                              _c("div", {}, [
                                _c("span", [_vm._v("手机验证码验证 账户")]),
                                _vm._v(" "),
                                _c("span", { staticClass: "phone" }, [
                                  _vm._v(_vm._s(_vm.findForm.phone))
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("为确认是你本人操作,请完成一下验证")
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("手机号")]),
                                _vm._v(" "),
                                _vm.nouse == false
                                  ? _c("el-input", {
                                      staticClass: "iptHeight",
                                      attrs: {
                                        type: "text",
                                        "auto-complete": "off",
                                        placeholder: "手机/用户名"
                                      },
                                      model: {
                                        value: _vm.findForm.phone,
                                        callback: function($$v) {
                                          _vm.$set(_vm.findForm, "phone", $$v)
                                        },
                                        expression: "findForm.phone"
                                      }
                                    })
                                  : _c("span", { staticClass: "yesuse" }, [
                                      _c("span", { staticClass: "phone" }, [
                                        _vm._v(_vm._s(_vm.findForm.phone))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "alter",
                                          on: {
                                            click: function($event) {
                                              return _vm.Nouse()
                                            }
                                          }
                                        },
                                        [_vm._v("[手机不可用?点此修改]")]
                                      )
                                    ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c("label", [_vm._v("验证码")]),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "280px" },
                                  attrs: { placeholder: "请输入验证码" },
                                  model: {
                                    value: _vm.setNew.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "code", $$v)
                                    },
                                    expression: "setNew.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.codeShow,
                                        expression: "codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn",
                                    on: {
                                      click: function($event) {
                                        return _vm.getCode(_vm.setNew.phone)
                                      }
                                    }
                                  },
                                  [_vm._v("获取验证码")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.codeShow,
                                        expression: "!codeShow"
                                      }
                                    ],
                                    staticClass: "codeBtn codeCount"
                                  },
                                  [
                                    _vm._v(
                                      "重新获取(" +
                                        _vm._s(_vm.codeCountNum) +
                                        "s)"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.FindSet()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            ),
                            _vm._v(" "),
                            _vm._m(11)
                          ])
                        : _vm.findStep == "2"
                        ? _c("div", { staticClass: "loginFormBox" }, [
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c(
                                  "label",
                                  { staticStyle: { width: "115px" } },
                                  [_vm._v("设置新密码")]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "password",
                                    "auto-complete": "off",
                                    placeholder: "请设置新密码"
                                  },
                                  model: {
                                    value: _vm.setNew.password,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "password", $$v)
                                    },
                                    expression: "setNew.password"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "inputBox" },
                              [
                                _c(
                                  "label",
                                  { staticStyle: { width: "115px" } },
                                  [_vm._v("确认新密码")]
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "iptHeight",
                                  attrs: {
                                    type: "password",
                                    "auto-complete": "off",
                                    placeholder: "请再次确认新密码"
                                  },
                                  model: {
                                    value: _vm.setNew.verify,
                                    callback: function($$v) {
                                      _vm.$set(_vm.setNew, "verify", $$v)
                                    },
                                    expression: "setNew.verify"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "loginBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.FindConfirm()
                                  }
                                }
                              },
                              [_vm._v("确定")]
                            )
                          ])
                        : _c("div", { staticClass: "regSuccess" }, [
                            _vm._m(12),
                            _vm._v(" "),
                            _c("div", { staticClass: "content" }, [
                              _c("div", { staticClass: "text" }, [
                                _vm._v("重置成功，请牢记新的登录密码噢~!")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "toLogin",
                                  on: { click: _vm.registered }
                                },
                                [_vm._v("重新登录")]
                              )
                            ])
                          ])
                    ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footText" }, [
            _vm._v(
              "\n      COPYRIGHT (©) 2021-2022保山数字产业发展有限责任公司 ALL RIGHTS RESERVED\n      滇ICP备2021004155号\n    "
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step steped" }, [
      _c("span", { staticClass: "number" }, [_vm._v("1")]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._v("验证手机号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "conTitle" }, [
      _c("span", { staticClass: "bigTitle" }),
      _vm._v(" "),
      _c("span", { staticClass: "smallTitle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leftImg" }, [
      _c("img", { attrs: { src: "", alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "findPassword" }, [
      _c("div", { staticClass: "icon" }, [
        _c("i", { staticClass: "el-icon-warning" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v("请输入你需要找回登录密码的账户名")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "el-icon-success" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step steped" }, [
      _c("span", { staticClass: "number" }, [_vm._v("1")]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._v("验证身份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputBox" }, [
      _c("div", { staticClass: "massage" }, [
        _c("p", { staticClass: "title" }, [_vm._v("没收到短信验证码?")]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    1.网络通讯异常可能会造成短信丢失,请重新获取或稍后再试。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    2.请核实手机是否欠费停机，或者屏蔽了系统短信。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    3.如果手机丢失或停用，请选择其他验证方式。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    4.您也可以尝试将SIM移动到另一部手机，然后重试。\n                  "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "el-icon-success" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "findPassword" }, [
      _c("div", { staticClass: "icon" }, [
        _c("i", { staticClass: "el-icon-warning" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "text" }, [
          _vm._v(
            "\n                  请输入你的身份证号和真姓名用于找回账户会员名（暂支持已完成注册认证的用户）\n                "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "el-icon-success" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "step steped" }, [
      _c("span", { staticClass: "number" }, [_vm._v("1")]),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [_vm._v("验证身份")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "inputBox" }, [
      _c("div", { staticClass: "massage" }, [
        _c("p", { staticClass: "title" }, [_vm._v("没收到短信验证码?")]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    1.网络通讯异常可能会造成短信丢失,请重新获取或稍后再试。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    2.请核实手机是否欠费停机，或者屏蔽了系统短信。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    3.如果手机丢失或停用，请选择其他验证方式。\n                  "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "item" }, [
          _vm._v(
            "\n                    4.您也可以尝试将SIM移动到另一部手机，然后重试。\n                  "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "el-icon-success" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a49090ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a49090ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/login.vue
// module id = null
// module chunks = 